module.exports = __webpack_public_path__ + "static/img/zx-banner.0ef0b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zx-banner.png
// module id = jwRW
// module chunks = 1